export default {
  hero_title_1: 'Kakobuy Spreadsheet',
  hero_title_2: 'Polska 2026',
  hero_subtitle: 'Znajdź najlepsze Kakobuy Finds, produkty i linki w jednym miejscu. Oszczędzaj czas i kupuj mądrzej dzięki uporządkowanym listom produktów.',
  hero_btn_primary: 'Kakobuy Spreadsheet',
  hero_btn_secondary: 'Kup teraz',
  hero_badge: 'Nowość 2026',
  section_categories_title: 'Przeglądaj kategorie',
  section_categories_subtitle: 'Odkryj produkty w popularnych kategoriach',
  section_about_title: 'Dlaczego Kakobuy Spreadsheet?',
  section_about_desc_1: 'Oszczędność czasu – zamiast godzinami przeszukiwać tysiące ofert, otrzymujesz gotową listę sprawdzonych produktów.',
  section_about_desc_2: 'Dostęp do trendów – znajdziesz produkty, które są obecnie najpopularniejsze wśród społeczności zakupowej.',
  section_about_desc_3: 'Lepsza organizacja – wszystkie informacje w jednym miejscu: nazwa, kategoria, cena i link do produktu.',
  section_about_desc_4: 'Dla początkujących – idealne rozwiązanie jeśli dopiero zaczynasz przygodę z zakupami z Chin.',
  section_articles_title: 'Poradniki i artykuły SEO',
  section_articles_subtitle: 'Wszystko co musisz wiedzieć o Kakobuy, zakupach z Chin i najlepszych znaleziskach.',
  section_cta_title: 'Gotowy na zakupy?',
  section_cta_subtitle: 'Przejdź do głównego serwisu i odkryj pełną listę produktów Kakobuy Spreadsheet.',
  section_cta_btn: 'Przejdź do Kakobuy Spreadsheet',
  article_preview_title: 'Kakobuy Spreadsheet – kompletny przewodnik',
  article_preview_desc: 'Dowiedz się czym jest Kakobuy Spreadsheet, jak z niego korzystać i dlaczego warto. Kompletny poradnik dla kupujących z Chin.',
  article_preview_tag: 'Poradniki',
  nav_shopping_guide: 'Poradnik zakupowy',
  section_articles_more: 'Więcej artykułów',
};